import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/ImageCard/sgds-image-card";
import { register } from "../../utils/ce-registry";

register("sgds-image-card", Component);

export default createComponent({
  react: React,
  tagName: "sgds-image-card",
  elementClass: Component,
  events: {}
});
